// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/GraphikRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/GraphikLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/GraphikThin.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Graphik';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'Graphik';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Graphik';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
    font-weight: 300;
    font-style: normal;
}

body {
    font-family: 'Graphik', sans-serif;
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/fonts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,+DAA0D;IAC1D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAwD;IACxD,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,+DAAuD;IACvD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["@font-face {\n    font-family: 'Graphik';\n    src: url('../fonts/GraphikRegular.otf') format('opentype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Graphik';\n    src: url('../fonts/GraphikLight.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Graphik';\n    src: url('../fonts/GraphikThin.otf') format('opentype');\n    font-weight: 300;\n    font-style: normal;\n}\n\nbody {\n    font-family: 'Graphik', sans-serif;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
